import React, { useCallback, useEffect, useState } from 'react';

import { hasRoles, CREATE_STUDY_ROLES, EDIT_STUDY_ROLES } from '../../../util/RoleUtil';

import { retrieveStudies } from '../../../services/StudyService';

import { AddSiteToStudy } from '../add-site-to-study/AddSiteToStudy';
import { Table } from '../../common/table/Table';
import Modal from '../../common/modal/Modal';

import './StudyTrialSearch.css';

export const StudyTrialSearch = ({ context, navigateTo, showToaster, setSpinnerText, navigateToWith }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = useCallback(async () => {
    setSpinnerText('Retrieving Studies / Trials');
    const [data, error] = await retrieveStudies(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        setSearchResults(data.studies);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  }, [setSpinnerText, setSearchResults, showToaster, context.username]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleRowClick = (studyTrial) => {
    navigateToWith('studyTrialEdit', 'studyTrialEditGeneral', studyTrial);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleAddSiteToStudyButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCreateNewButtonClick = () => {
    navigateTo('studyTrialCreate');
  };

  if (!searchResults) return null;

  return (
    <div className="study-trial-search">
      <Table
        tableData={searchResults}
        hiddenColumns={['facilityExternalReference', 'studyExternalReference']}
        searchEnabled={true}
        filterEnabled={true}
        onRowClick={handleRowClick}
        tableTitle="Study / Trial Administration"
        buttonText={hasRoles(context, EDIT_STUDY_ROLES) ? 'Add Site To A Study' : undefined}
        buttonTwoText={hasRoles(context, CREATE_STUDY_ROLES) ? 'Create New Study' : undefined}
        onButtonClick={handleAddSiteToStudyButtonClick}
        onButtonTwoClick={handleCreateNewButtonClick}
        buttonOneWidth={'200px'}
        buttonTwoWidth={'200px'}
        maxRowCount={10}
        horizontalScroll
      />
      {isModalOpen && (
        <Modal
          closeModal={closeModal}
          setIsModalOpen={setIsModalOpen}
          headerTitle={'Add Site To A Study'}
          buttonTitle={'Save'}
          width={'1000px'}
          height={'max-content'}
          contentPadding={'2px'}
          justifyContent={'center'}
          hideButton={true}
        >
          <AddSiteToStudy
            context={context}
            setSpinnerText={setSpinnerText}
            showToaster={showToaster}
            setIsModalOpen={setIsModalOpen}
            navigateToWith={navigateToWith}
          />
        </Modal>
      )}
    </div>
  );
};
